module.exports = __webpack_public_path__ + "static/media/meditation17.8950149b.mp3";